export default __webpack_public_path__ + "static/media/object-trash_darkGray3.2bb765a0.svg";